const state = () => ({
    music: false
})

const mutations = {
    setMusic(state, { music }) {
        state.music = music
    },
    clearAll(state) {
        state.music = false
    }
}

const actions = {
    async setMusic({ commit, dispatch }, { music }) {
        await commit('setMusic', { music })
        dispatch('price/setPrice', null, { root: true })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}


const getters = {
    music: state => state.music
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};